<template>
  <div>
    <p>If you are looking to disable Two Factor Authentication, please confirm your password and Click Disable 2FA Button.</p>

    <div class="form-group">
      <label for="password" class="control-label" />
      <input
        id="password"
        v-model="password"
        type="password"
        class="form-control col-md-4"
        placeholder="Current Password"
        name="password"
        required
      >
    </div>
    <button type="submit" class="btn btn-primary" @click="disableGoogle2fa">
      Disable 2FA
      <span v-if="loading" class="btn-loader" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'DisableGoogle2FA',

  data: () => ({
    password: '',
    loading: false,
  }),

  methods: {
    isFormValid() {
      if (!this.password) {
        this.$emit('getErrors', 'Please pass Current Password field.');
        return false;
      }
      return true;
    },
    disableGoogle2fa() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      const postFormData = new FormData();
      postFormData.append('password', this.password);
      this.$apiHttp.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}2fa/disable`, postFormData)
        .then((response) => {
          if (response.data.success) {
            this.$emit('getErrors', null);
            const newValue = {
              ...JSON.parse(localStorage.getItem(this.$config.userStorage.name)),
              google2fa_enabled: false,
            };
            localStorage.setItem(this.$config.userStorage.name, JSON.stringify(newValue));
            this.$store.commit('user/setGoogle2faInfo', false);
            this.$emit('resetSecretKey');
          }
        })
        .catch((e) => {
          if (e.response) {
            this.$emit('getErrors', e.response.data.message);
          } else {
            this.$emit('getErrors', e.message);
            console.log('Error', e.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// DisableGoogle2FA.vue?5371ff72